import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { clearWorkflowSaved, saveWorkflow } from './store/workflow/actions';

import EmptyState from './empty_state';
import SaveButton from 'components/form/save_button';
import Step from './step';
import WarningModal from './warning_modal';

export const VoucherApprovalWorkflow = ({ clearWorkflowSaved, saveWorkflow, workflow }) => {
  const [showModal, setShowModal] = useState(false);

  let steps;
  if (workflow.steps.length === 0) {
    steps = <EmptyState />;
  } else {
    steps = workflow.steps.map((step, i) => <Step index={i} key={i} step={step} />);
  }

  const handleSave = () => {
    if (workflow.activeVoucherCount) {
      setShowModal(true);
    } else {
      saveWorkflow();
    }
  };

  return <>
    {steps}

    <div className="d-flex align-items-center">
      <SaveButton
        label="Save Workflow"
        labelLocation="right"
        saved={workflow.saved}
        saving={workflow.saving}
        onClick={handleSave}
        onSavedAcknowledgement={clearWorkflowSaved}
      />

      <div className="ms-3 text-danger">{(workflow.errors || []).join(', ')}</div>
    </div>

    <WarningModal
      show={showModal}
      voucherCount={workflow.activeVoucherCount}
      onConfirm={saveWorkflow}
      onHide={() => setShowModal(false)}
    />
  </>;
};

VoucherApprovalWorkflow.propTypes = {
  clearWorkflowSaved: PropTypes.func.isRequired,
  saveWorkflow: PropTypes.func.isRequired,
  workflow: PropTypes.shape({
    activeVoucherCount: PropTypes.number,
    errors: PropTypes.array,
    steps: PropTypes.array.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  workflow: state.workflow
});

const mapDispatchToProps = {
  clearWorkflowSaved,
  saveWorkflow,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherApprovalWorkflow);
